import type { ComponentType } from "react";

import { cn } from "@bigpp/ui/lib/utils";

// AI Elements-inspired Actions row: hover-revealed strip of small icon/label
// buttons below a message. Each Action is compact and low-contrast until
// hovered.

export function Actions({
  className,
  children,
  align = "start",
  alwaysVisible = false,
}: {
  className?: string;
  children: React.ReactNode;
  align?: "start" | "end";
  alwaysVisible?: boolean;
}) {
  return (
    <div
      className={cn(
        "flex items-center gap-2 transition-all duration-150",
        align === "end" ? "justify-end" : "justify-start",
        alwaysVisible
          ? "opacity-100"
          : "opacity-0 translate-y-0.5 group-hover:opacity-100 group-hover:translate-y-0",
        className,
      )}
    >
      {children}
    </div>
  );
}

type ActionProps = {
  onClick?: () => void;
  icon: ComponentType<{ className?: string }>;
  label?: React.ReactNode;
  title?: string;
  disabled?: boolean;
};

export function Action({ onClick, icon: Icon, label, title, disabled }: ActionProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={title}
      className="flex items-center gap-1 text-[10px] text-[var(--color-muted-foreground)] hover:text-[var(--color-foreground)] transition-colors disabled:opacity-50"
    >
      <Icon className="size-2.5" />
      {label}
    </button>
  );
}
